import React from "react";
import { FaSearch } from "react-icons/fa";
import "../styles/searchInput.css"; // optional for styling

const SearchInput = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <div className="search1-container">
      <input
        type="search"
        className="search1-input"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchInput;
